import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  IonGrid,
  IonIcon,
  IonRouterLink,
  IonRow,
  IonSearchbar,
} from "@ionic/react";
import "./UserChatPage.scss";
import _ from "lodash";
import { utilService } from "../../services";
import MessageListCard from "../../components/Shared/MessageListCard/messageListCard";
import Loader from "../../components/Shared/Loader/Loader";
import { UserChatService } from "./UserChat.service";
import { close } from "ionicons/icons";
import { Link, useHistory } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { CONSTANTS } from "../../constants";
import { useToast } from "@agney/ir-toast";
interface UserChatComponentProps {
  isModalPopUpScreen?: boolean;
  dataFromParentComponent?: any;
  onCancel?: () => void;
  fromHomePage?: boolean;
  fromHomePageSmallScreen?: boolean;
}

const nextPage = "usermessages";

const UserChatComponent: React.FC<UserChatComponentProps> = (props) => {
  const { t } = useTranslation("messages");
  const [searchText, setSearchText] = useState("");
  const [messageListData, setMessageListData]: any = useState([]);
  const [messageNextValue, setMessageNextValue]: any = useState("");
  const [isShowPopOver, setShowPopover] = useState(false);
  const [initialMsgListData, setInitialMsgListData] = useState([]);
  const [isMessageLoaderActive, setIsMessageLoaderActive] = useState(true);
  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [isShowSelectUserModal, setIsShowSelectUserModal] = useState(false);
  const Toast = useToast();
  const history = useHistory();


  useEffect(() => {
    fetchMessageDetails();
  }, [searchText]);

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  async function fetchMessageDetails(page: number = 1) {
    if (page === 1) {
      setIsMessageLoaderActive(true);
    }
    const params = {
      timezone,
      searchQuery: searchText,
      pageNumber: page,
    };
    // const params = setMessageListParams(searchText, page);
    const respMessageListResult: any = await UserChatService.getMessageListData(
      params
    );
    if(respMessageListResult?.isSuccess){
        const newData = respMessageListResult?.result?.[0]?.data || [];
     if (page === 1) {
    setMessageListData(newData);
  } else {
    setMessageListData((prev: any) => [...prev, ...newData]);
  }

    }else{
      Toast.error(respMessageListResult?.message);
    }
    // `result` is absent on a failed call, so indexing it threw and took the
    // whole Messages page down with a white screen instead of showing the
    // error toast above.
    setMessageNextValue(respMessageListResult?.result?.[0]?.next);
    setIsMessageLoaderActive(false);
  }

  const setMessageListParams = (searchedText: string, page: number = 1) => {
    return {
      search_text: searchedText,
      page: page,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      reg_code: utilService.getNetwork(),
    };
  };

  const onScroll = () => {
    if (!_.isEmpty(messageNextValue)) {
   const nextPage = pageNo + 1;
setPageNo(nextPage);
fetchMessageDetails(nextPage);
    }
  };

  const updateMessageList = (listData: any) => {
    if (listData) {
      fetchMessageDetails(1);
    }
  };

  const updateMsgView = () => {
    fetchMessageDetails(1);
  };

  return (
    <div className="user-chat-container">
      {isMessageLoaderActive && (
        <div className="loader-container">
          <Loader></Loader>
        </div>
      )}
      {!props.fromHomePage && (
        <>
          {!props.fromHomePageSmallScreen && (
            <>
              <div
                className={`file-share-select-user-header ${
                  props.isModalPopUpScreen
                    ? "file-share-select-user-header-height"
                    : ""
                }`}
              >
                <div className="header-label">{t("messages")}</div>
              </div>
              <div className="dropdown-main-container">
                <div className="searchbar-containar-item">
                  <IonSearchbar
                    debounce={1000}
                    value={searchText}
                    disabled={isShowPopOver}
                    onIonChange={(e) => {
                      setSearchText(e.detail.value!);
                    }}
                    onIonClear={(e) => {
                      setSearchText("");
                      setPageNo(1);
                    }}
                    placeholder={t("search")}
                    type="search"
                    autocomplete="off"
                    autoCorrect="off"
                    className="searchbar"
                  ></IonSearchbar>
                </div>
                <div className="message-share-icon-div">
                  <div
                    className="add-new-media-icon-div"
                    onClick={(e: any) => {
                      setShowPopover(!isShowPopOver);
                    }}
                  >
                      <div className="add-media-icon" title={t("messageMediaShare")}>
                      <div
                        className="input-icon"
                        onClick={() => {
                          setShowPopover(false);
                        }}
                      >
                        <IonIcon className="icon-add"></IonIcon>
                      </div>
                    </div>
                    <div
                      className={`file-attach-media-message-sm ${
                        isShowPopOver ? "show-popover" : "hide-popover"
                      }`}
                    >
                      <div className="close-icon">
                        <IonIcon icon={close}></IonIcon>
                      </div>
                      <div className="attach-media-messages-icons-wrapper">
                        <div className="add-new-media-icon-div new-msg-icon">
                          <div className="add-media-icon ">
                            <Link
                              to={{
                                pathname: "/client/usermessages",
                                state: {
                                  selectUser: true,
                                },
                              }}
                            >
                              <span
                                className="icon-speech-bubble icon-msg-add"
                                title={t("message")}
                              ></span>
                            </Link>
                          </div>
                        </div>
                        <div
                          className="add-new-media-icon-div new-media-icon"
                          title="Media Share"
                        >
                          <div className="add-media-icon">
                            <IonRouterLink routerLink="/client/file-share/selectuser">
                              <span className="icon-media icon-msg-add"></span>
                            </IonRouterLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
      {!props.fromHomePageSmallScreen && (
        <IonGrid
          className={`message-page-grid ${
            props.fromHomePage ? "home-message-list" : ""
          }`}
        >
          <InfiniteScroll
            className="message-section-list-infinity-scroll"
            dataLength={messageListData.length}
            next={() => onScroll()}
            hasMore={true}
            loader={<div></div>}
          >
            <IonRow className="site-list-container">
              {!_.isEmpty(messageListData)
                ? messageListData.map((item: any, index: any) => (
                    <MessageListCard
                      key={item.id}
                      listData={item}
                      index={index}
                      isShowPopOver={isShowPopOver}
                      componentName={nextPage}
                      isFromHomeSection={true}
                      fromHomePage={props.fromHomePage}
                      getSelectedMessageCard={updateMessageList}
                      updateList={updateMsgView}
                      isShowSelectUserModal={isShowSelectUserModal}
                      setIsShowSelectUserModal={setIsShowSelectUserModal}
                      handleClick={() => {
                        history.push({
                          pathname: "/client/messages",
                          state: {
                            selectedDoctorData: item?.thread_users,
                            clickedMessage:item,
                            mediaAction: CONSTANTS.MEDIA_ACTIONS.SEND,
                            isFullscreen: false,
                          },
                        });
                      }}
                    />
                  ))
                : !isMessageLoaderActive && messageListData?.length === 0 && (
                    <div className="no-results-label">
                      {t("noMessagesAvailable")}
                    </div>
                  )}
            </IonRow>
          </InfiniteScroll>
        </IonGrid>
      )}

      {props.fromHomePageSmallScreen && (
        <div className="home-message-list-container">
          <div className="sub-header header-color">{t("newMessages")}</div>
          <ul>
            {!_.isEmpty(messageListData)
              ? messageListData.map((item: any, index: any) => (
                  <li className="message-list">
                    <Link
                      to={{
                        pathname: `/client/messages`,
                      }}
                    >
                      {item.text}
                    </Link>
                  </li>
                ))
              : !isMessageLoaderActive && (
                  <li className="no-results-label">{t("noMessagesAvailable")}</li>
                )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserChatComponent;
